import { render, staticRenderFns } from "./IndexManager.vue?vue&type=template&id=03071b83&scoped=true"
import script from "./IndexManager.vue?vue&type=script&lang=js"
export * from "./IndexManager.vue?vue&type=script&lang=js"
import style0 from "./IndexManager.vue?vue&type=style&index=0&id=03071b83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03071b83",
  null
  
)

export default component.exports